(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["nav-menu"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.nav-menu__list-item').forEach(item => {
  const link = item.querySelector('.nav-menu__list-link[aria-haspopup="true"]');
  if (!link) return;
  let touchedOnce = false;
  const openMenu = () => link.setAttribute('aria-expanded', 'true');
  const closeMenu = () => {
    link.setAttribute('aria-expanded', 'false');
    touchedOnce = false;
  };
  link.addEventListener('touchstart', e => {
    if (!touchedOnce) {
      e.preventDefault();
      link.focus();
      touchedOnce = true;
      openMenu();
    } else {
      window.location.href = link.getAttribute('href');
    }
  });
  item.addEventListener('mouseenter', openMenu);
  item.addEventListener('touchstart', openMenu);
  item.addEventListener('mouseleave', closeMenu);
  document.addEventListener('touchstart', e => {
    if (!item.contains(e.target)) closeMenu();
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tabs"] && !Shopify.designMode) return;
  try {
    const initTabLogic = () => {
  document.querySelectorAll('.tabs').forEach((tabsContainer) => {

    const detailsElements = Array.from(tabsContainer.querySelectorAll(':scope > .tabs__details'));
    if (detailsElements.length === 0) return;

    const hash = window.location.hash.replace('#', '');
    const hashMatch = detailsElements.find(details => details.id === hash);
    
    if (hashMatch) {
      hashMatch.open = true

      if (!Shopify.designMode) {
        setTimeout(() => {
          tabsContainer.scrollIntoView({ 
            behavior: 'instant', 
            block: 'start' 
          });
        }, 100);
      }

    } else {
      detailsElements[0].open = true
    }
  });
};

document.addEventListener('DOMContentLoaded', initTabLogic);
document.addEventListener('shopify:section:load', initTabLogic);

document.addEventListener('shopify:block:select', (event) => {
  const blockId = event.detail.blockId;
  const target = document.getElementById(`tabs-panel-${blockId}`) || 
                 document.querySelector(`[data-shopify-editor-block*="${blockId}"]`);

  if (target) {
    const parentDetails = target.closest('details');
    if (parentDetails) {
      parentDetails.open = true;
    }
  }
});
  } catch(e) { console.error(e); }
})();

})();
